module.exports = __webpack_public_path__ + "img/img-chuanyuan-s1.17185a43.jpg";